import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Payment} from '../../../shared/models/account/payment';
import {RequestMethod, RestService} from '../../../shared/services/rest.service';
import {Actions, ApiEndpoints} from '../../../shared/constants/ApiEndpoints';
import {PageableResponse} from '../../../shared/models/datasource/pageable-response';
import {Journal} from '../../../shared/models/account/journal';
import {Company} from '../../../shared/models/res/company';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {State} from '../../../shared/models/res/state';
import {CountriesEnum} from '../../../shared/enums/res/Countries';
import {Country} from '../../../shared/models/res/country';
import {LocationService} from '../../../shared/services/location.service';
import {ResponseSnackbarService} from '../../../shared/services/response-snackbar.service';
import {Partner} from '../../../shared/models/res/partner';
import {MatStepper} from '@angular/material/stepper';
import {GeneralConstant} from '../../../shared/constants/GeneralConstant';
import {StripeService, StripeCardComponent, StripePaymentElementComponent} from 'ngx-stripe';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  PaymentIntent, StripeElementChangeEvent, StripePaymentElementChangeEvent
} from '@stripe/stripe-js';
import {User} from '../../../shared/models/res/user';
import {TokenService} from '../../../shared/services/token.service';
import {Observable, Subject} from 'rxjs';
import {PermissionLink} from '../../../shared/permission/PermissionLink';
import {reactiveFormValidator} from '../../../shared/utils/Reactive-form-validation-trigger';
import {environment} from '../../../../environments/environment';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {Util} from '../../../shared/utils/Util';
import {Invoice} from '../../../shared/models/account/invoice';
import {PaymentTypeEnum} from '../../../shared/models/account/PaymentType.enum';
import {MessageInfo} from '../../../shared/enums/error-messages/MessageInfo';
import {TooltipService} from '../../../shared/services/tooltip.service';
import {roles} from '../../../shared/enums/res/roles';

@Component({
  selector: 'app-payment-checkout',
  templateUrl: './payment-checkout.component.html',
  styleUrls: ['./payment-checkout.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class PaymentCheckoutComponent implements OnInit {
  firstshow = false;
  show = false;
  panelOpenState = false;
  maxNumberOfCharacters = 2000;
  counter = true;
  numberOfCharacters = 0;
  termsAccepted = false;
  interaction = {
    textValue: ''
  };
  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  @ViewChild(StripePaymentElementComponent)
  paymentElement: StripePaymentElementComponent;
  /**
   * Invoice id
   */
  invoiceId: any;

  facilityId: any;

  isBillingDisabled = false;

  /**
   * Invoice
   */
  invoice: any;

  /**
   * Journals
   */
  journals: any;

  /**
   * Selected journal
   */
  selectedJournal: any;

  /**
   * Company
   */
  company: any;

  /**
   * Facility
   */
  facility: any;

  /**
   * Billing form group
   */
  billingFormGroup: FormGroup;

  /**
   * Currency Symbols
   */
  currencySymbolBefore: any;
  currencySymbolAfter = ' USD';

  /**
   * Country and states list
   */
  countryList: Country[] = [];
  stateList: State[] = [];
  countyList: any[] = [];

  usaId = CountriesEnum.USA;


  stripeForm: FormGroup = null;
  confirmBtnDisabled: boolean;

  checked: boolean;
  /**
   * Element options
   */
  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };
  paying = false;
  /**
   * User.
   */
  user: User;

  appearance = {
    theme: 'stripe',
    labels: 'floating'
  };

  response = 'Your payment has been processed.';

  /**
   * Show elements base on pageOrigin.
   * Case 1: Hide stripe form on billing information page.
   */
  @Input() pageOrigin = '';

  /**
   * List of cards.
   */
  public cards;

  /**
   * Default card.
   */
  public defaultCard: string;
  addNewCard = false;
  /**
   * Permissions
   */
  public permissions: {
    canUserCreate?: any;
    canUserUpdate?: any;
    canUserCreateAndUpdateCard?: any;
    canUserDeleteCard?: any;
  };
  @Input() events: Observable<void>;
  /**
   * Payment form group
   */
  paymentFormGroup: FormGroup;
  creditCardIcon = '/assets/images/icons/credit-card.svg';
  /**
   * Is bank transfer
   */
  isBankTransfer = false;
  /**
   * Payment
   */
  payment: Payment = new Payment();

  /**
   * Is Stripe Payment
   */
  isStripePayment = false;

  isStripePaymentMethod = false;
  /**
   * Use card as guest checkbox
   */
  useCardAsGuestBtn = true;
  /**
   * Save card Disabled
   */
  saveCardDisabled = false;

  /**
   * Save payment
   */
  savePayment = false;


  prefix: Country = {
    id: 235,
    code: 'US',
    phoneCode: '1'
  };

  isInvoiceSelect: any;
  isFacApplication: any;

  amountToPay: number;

  totalDue: number;

  discount: number;

  processingFee: number;

  financeFees: any;

  subTotal: number;

  discountPercentage: number;

  showBtnExistingPaymentMethod = true;
  form: FormGroup;
  /**
   * Invoices
   */
  invoices: Invoice[] = [];
  optionalInvoices: Invoice[] = [];
  mandatoryInvoices: Invoice[] = [];

  isInvoiceForm = false;

  defaultPaymentMethodId: string;
  paymentMethod = 'STRIPE';
  paymentIntentId: string;
  setForFuturePayment: boolean;
  isStaff = false;
  isAdmin = false;

  protected onDestroy = new Subject<void>();
  @ViewChild('stepper', {static: true}) private myStepper: MatStepper;
  defaultInvalid = MessageInfo.LIMIT_2_AND_100;
  defaultRequired = MessageInfo.REQUIRED_FIELD;
  defaultExists = MessageInfo.ALREADY_EXISTS;
  invalidEmail = MessageInfo.LIMIT_6_AND_100;
  invalidAddress = MessageInfo.LIMIT_1_AND_255;
  invalidZip = MessageInfo.LIMIT_1_AND_10;
  invalidChar = MessageInfo.LIMIT_1_AND_100;
  invalidDesc = MessageInfo.LIMIT_1_AND_2000;
  tooltipService: any;

  constructor(private activatedRoute: ActivatedRoute,
              private restService: RestService,
              private locationService: LocationService,
              private responseSnackBar: ResponseSnackbarService,
              private tokenService: TokenService,
              private stripeService: StripeService,
              private fb: FormBuilder,
              private router: Router) {
    if (activatedRoute.snapshot.params.id) {
      this.facilityId = activatedRoute.snapshot.params.id;
    } else {
      this.isBillingDisabled = true;
    }
    this.activatedRoute.queryParamMap
      .subscribe(params => {
        if (params.get('location') === 'checkout') {
          this.isFacApplication = true;
          this.isInvoiceSelect = false;
        } else if (params.get('location') === 'invoice') {
          this.isInvoiceSelect = true;
          this.isFacApplication = false;
          if (params.get('part') === 'form') {
            this.isInvoiceForm = true;
          }
        } else {
          this.isFacApplication = false;
          this.isInvoiceSelect = false;
        }
      });
  }

  ngOnInit() {
    this.getProcessingFees();
    this.getAllCountries();
    this.getJournals();
    this.getCompanyInfo();
    this.user = this.tokenService.getUserFromToken();
    this.getAllCards();
    this.initPermissions();
    this.initStripeForm();
    this.isStaff = this.tokenService.getRolesFromToken().some(it => it === roles.STAFF.name);
    this.isAdmin = this.tokenService.getRolesFromToken().some(it => it === roles.GLOBAL_ADMIN.name || it === roles.ADMIN.name
      || it === roles.FINANCE_DIRECTOR.name || it === roles.FINANCE_SPECIALIST.name);
  }

  onKeyUp(event: any): void {
    this.numberOfCharacters = event.target.value.length;

    if (this.numberOfCharacters > this.maxNumberOfCharacters) {
      event.target.value = event.target.value.slice(0, this.maxNumberOfCharacters);
      this.numberOfCharacters = this.maxNumberOfCharacters;
    }
  }

  termsAcceptedChange(event) {
    this.termsAccepted = event.checked;
  }

  getProcessingFees() {
    this.restService.request<PageableResponse<any>>(RequestMethod.GET, ApiEndpoints.ACCOUNT.PAYMENT, `read/fees/${this.facilityId}`)
      .subscribe(response => {
        if (response.success) {
          if (response.data) {
            this.financeFees = response.data;
          }
          this.getInvoices();
          return;
        }
      });
  }

  /**
   * Get invoices
   */
  getInvoices() {
    this.restService.request<PageableResponse<any>>(RequestMethod.GET, ApiEndpoints.ACCOUNT.INVOICE, `read/by_facility/${this.facilityId}`)
      .subscribe(response => {
        if (response.success) {
          if (response.data) {
            const invoices = response.data as any;
            invoices.forEach(invoice => {
              invoice.amountToPay = invoice.amountResidual;
              if (new Date(invoice.dateDue) > new Date() && new Date(invoice.tolerance) > new Date()) {
                this.optionalInvoices.push(JSON.parse(JSON.stringify(invoice)));
              } else {
                this.mandatoryInvoices.push(JSON.parse(JSON.stringify(invoice)));
              }
            });
            this.invoices = JSON.parse(JSON.stringify(this.mandatoryInvoices));
            if (this.invoices.length === 0 && this.optionalInvoices.length > 0) {
              this.invoices.push(JSON.parse(JSON.stringify(this.optionalInvoices[0])));
            }
            this.initForm();
            this.getFacilityData();
            this.updateAmountToPay();

          }
          return;
        }
      });
  }


  setPrefix(event: any) {
    if (event.isUserInput) {
      this.prefix = this.countryList.filter(item => (item.id === event.source.value))[0];
    }
  }
  get optionalInvoiceControls(): FormArray {
    return this.form.get('optionalInvoices') as FormArray;
  }

  get mandatoryInvoiceForms(): FormArray {
    return this.form.get('mandatoryInvoices') as FormArray;
  }
  getJournals() {
    const data = {
      fields: ['aj.id', 'aj.name', 'aj.type'],
      tables: ['account_journal aj'],
      conditions: [['deleted', 'IS', false]]
    };
    this.restService.request<PageableResponse<Journal>>(RequestMethod.GET, ApiEndpoints.ACCOUNT.JOURNAL, Actions.BASE_ACTIONS.READ).subscribe(
      response => {
        if (response.success && response.data) {
          this.journals = response.data;
          if (this.journals.length > 0) {
            this.selectedJournal = this.journals[0].id;
          }
        }
      });
  }

  payStripeSavedPM(event, stepper: MatStepper) {
    this.defaultPaymentMethodId = this.cards.filter(it => it.id === this.defaultCard)[0].id;
    this.paymentMethod = this.cards.filter(it => it.id === this.defaultCard)[0]?.funding;
    this.payment.paymentMethodId = this.defaultPaymentMethodId;
    this.payment.intent = true;
    this.payment.createIntent = false;
    this.payment.journal = this.paymentMethod === 'us_bank_account' ? this.journals.filter(x => x.type === 'STRIPE_ACH')[0] : this.journals.filter(x => x.type === 'STRIPE')[0];

    this.createPaymentIntent().subscribe(pi => {
      this.payment.ref = pi.id;
      const action = 'update/payment_create';
      this.restService.request<Payment>(
        RequestMethod.POST,
        ApiEndpoints.ACCOUNT.PAYMENT,
        action,
        {
          body: this.payment
        }
      ).subscribe(response => {
        if (response.success) {
          if (this.paymentMethod === 'us_bank_account') {
            this.stripeService
              .confirmUsBankAccountPayment(pi.client_secret, {
                payment_method: this.payment.paymentMethodId,
              }).subscribe(pi1 => {
              if (pi1.error) {
                // Show error to your customer (e.g., insufficient funds)
                this.responseSnackBar.onResponseMessage(pi1.error.message, GeneralConstant.SNACKBAR_ERROR_CLASS);
                // alert({ success: false, error: result.error.message });
                event.onComplete();
              } else {
                // The payment has been processed!
                //   if (result.paymentIntent.status === 'succeeded') {
                // Show a success message to your customer
                this.response = 'ACH payment is now being processed and should be completed in a 2-5 business days.';
                stepper.next();
                //          alert({ success: true });
                //    }
              }
            });
          } else if (this.paymentMethod === 'card') {
            this.stripeService
              .confirmCardPayment(pi.client_secret, {
                payment_method: this.payment.paymentMethodId,
              }).subscribe(pi2 => {
              if (pi2.error) {
                // Show error to your customer (e.g., insufficient funds)
                this.responseSnackBar.onResponseMessage(pi2.error.message, GeneralConstant.SNACKBAR_ERROR_CLASS);
                event.onComplete();
                // alert({ success: false, error: result.error.message });
              } else {
                // The payment has been processed!
                //   if (result.paymentIntent.status === 'succeeded') {
                // Show a success message to your customer
                stepper.next();
                //   alert({ success: true });
                //    }
              }
            });
          }
        } else {
          this.responseSnackBar.onResponseMessage(response?.error?.message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
          event.onComplete();
        }
      });
    });
  }

  payStripe(event, stepper: MatStepper) {
    if (!this.paying && this.savePayment) {
      this.paying = true;
      this.payment.ref = this.paymentIntentId;
      this.payment.intent = true;
      this.payment.setForFuturePayments = this.setForFuturePayment;
      const action = 'update/payment_create';
      this.payment.journal = this.journals.filter(x => x.type === this.paymentMethod)[0];

      this.restService.request<Payment>(
        RequestMethod.POST,
        ApiEndpoints.ACCOUNT.PAYMENT,
        action,
        {
          body: this.payment
        }
      ).subscribe((response: any) => {
        if (response.success) {
          const URL = `https://predev.wp.quada.org/api/p1/payment-success`;
          this.stripeService.confirmPayment({
            elements: this.paymentElement.elements,
            confirmParams: {
              return_url: URL,
              payment_method_data: {
                billing_details: {
                  name: this.billingFormGroup.get('billingFirstName').value || '',
                  email: this.billingFormGroup.get('billingEmail').value || '',
                  address: {
                    line1: this.billingFormGroup.get('billingAddress').value || '',
                    postal_code: this.billingFormGroup.get('billingZip').value || '',
                    city: this.billingFormGroup.get('billingCity').value || '',
                  }
                }
              }
            },
            redirect: 'if_required'
          }).subscribe((result: any) => {
            this.paying = false;
            if (result.error) {
              this.payment.createIntent = true;
              // Show error to your customer (e.g., insufficient funds)
              this.responseSnackBar.onResponseMessage(result.error.message, GeneralConstant.SNACKBAR_ERROR_CLASS);
              // alert({ success: false, error: result.error.message });
              this.createPaymentIntent()
                .subscribe(pi => {
                  this.paymentIntentId = pi.id;
                  this.elementsOptions.clientSecret = pi.client_secret;
                });
              event.onComplete();
            } else {
              stepper.next();
              if (result.paymentIntent.status === 'requires_action' && result.paymentIntent.next_action.type === 'verify_with_microdeposits') {
                this.response = 'Micro-deposits initiated\n' +
                  'Expect a $0.01 deposit to the account  in 1-2 business days and an email with additional instructions to verify your bank account.';
              } else if (result.paymentIntent.status === 'processing') {
                this.response = 'ACH The payment is now being processed and should be completed in 2-5 business days.';
              }
            }
          });
        } else {
          this.paying = false;
          this.responseSnackBar.onResponseMessage(response?.error?.message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
          event.onComplete();
        }
      });
    } else {
      this.responseSnackBar.onResponseMessage('Please Provide All Information', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      event.onComplete();
    }
  }

  private createPaymentIntent(): Observable<PaymentIntent> {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.UPDATE}/payment_intent`;
    return this.restService.restRequest(
      RequestMethod.POST,
      URL,
      {
        body: this.payment
      }
    );
  }

  /**
   * Re-render cards whenever the card is set default or deleted.
   *
   * @param cardItemChanged cardItemChanged
   */
  onStripeItemChanged(cardItemChanged): void {
    if (cardItemChanged) {
      this.getAllCards();
    }
  }

  onChange(ev: StripePaymentElementChangeEvent) {
    if (ev.value.type === 'us_bank_account') {
      this.paymentMethod = 'STRIPE_ACH';
    } else if (ev.value.type === 'card') {
      this.paymentMethod = 'STRIPE';
    }
    this.updateAmountToPay();
    if (ev.complete) {
      this.savePayment = true;
    } else {
      this.savePayment = false;
    }
  }

  /**
   * Get billing info by facility
   */
  getFacilityData() {
    this.restService.publicRequest<any>(RequestMethod.GET, '/p1/' + ApiEndpoints.RES.FACILITY, `read/facility/guest/${this.facilityId}`).subscribe(
      response => {
        if (response.success && response.data) {
          this.facility = response.data;
          this.payment.partner = this.facility.partner;
          this.fillData();
        }
      }
    );
  }
  updatePayAmountMandatory(event, invoice, index) {

      const control = this.mandatoryInvoiceForms.at(index).get('amountMandatory');
      // if(control.value >  this.optionalInvoices[index].amountResidual){
      //   this.optionalInvoiceControls.at(index).get('amountOptional').setValue(this.optionalInvoices[index].amountResidual);
      // }
      this.mandatoryInvoices[index].amountToPay = this.mandatoryInvoiceForms.at(index).get('amountMandatory').value;
      this.invoices = JSON.parse(JSON.stringify(this.invoices.filter(it => it.id !== invoice)));
      this.invoices.push(JSON.parse(JSON.stringify(this.mandatoryInvoices.find(it => it.id === invoice))));

      this.updateAmountToPay();
  }
  updatePayAmount(event, invoice, index) {
      if (this.checked) {
      //  const control = this.optionalInvoiceControls.at(index).get('amountOptional');
        this.invoices = JSON.parse(JSON.stringify(this.invoices.filter(it => it.id !== invoice)));
        this.optionalInvoices[index].amountToPay = this.optionalInvoiceControls.at(index).get('amountOptional').value;

        this.invoices.push(JSON.parse(JSON.stringify(this.optionalInvoices.find(it => it.id === invoice))));
    } else {
      this.invoices = JSON.parse(JSON.stringify(this.invoices.filter(it => it.id !== invoice)));
    }
      this.updateAmountToPay();
  }
  updateInvoicesToPay(event, invoice, index) {
    const control = this.optionalInvoiceControls.at(index).get('amountOptional');
    this.optionalInvoices[index].amountToPay = this.optionalInvoiceControls.at(index).get('amountOptional').value;
    if (event.checked) {
      control.enable();
      this.checked = true;
      this.invoices.push(JSON.parse(JSON.stringify(this.optionalInvoices.find(it => it.id === invoice))));
    } else {
      control.disable();
      this.checked = false;
      control.setValue(this.optionalInvoices[index].amountResidual);
      this.invoices = JSON.parse(JSON.stringify(this.invoices.filter(it => it.id !== invoice)));
    }
    this.updateAmountToPay();
  }

  isInvoiceOptionChecked(invoiceId) {
    return this.invoices.some(it => it.id === invoiceId);
  }

  /**
   * Update payment amount
   */
  updateAmountToPay(){
    let paymentAmount = this.invoices.reduce((sum, item) => sum + item.amountToPay, 0) || 1;
    let journal = (this.isBankTransfer ? 'BANK' : this.paymentMethod);
    if (!this.isBankTransfer && !this.isStripePaymentMethod) {
      this.paymentMethod = this.cards?.filter(it => it.id === this.defaultCard)[0]?.funding;
      journal = this.paymentMethod === 'us_bank_account' ? this.journals.filter(x => x.type === 'STRIPE_ACH')[0].type : this.journals.filter(x => x.type === 'STRIPE')[0].type
    }
    this.processingFee = +this.setFinanceProcessingfee(paymentAmount, journal);
    paymentAmount = +(paymentAmount + this.processingFee).toFixed(2);
    this.paymentFormGroup?.controls.amount.setValue(paymentAmount);
    this.amountToPay = paymentAmount;
    this.payment.amount = paymentAmount;
  }

  setFinanceProcessingfee(paymentAmount, journal): number {
    const fee = journal ? this.financeFees?.find(item => journal === item?.journal?.find(it => it?.type === journal)?.type) : null;
    return fee ? ((((paymentAmount + fee.fixedAmount) / (1 - ((fee.percentage || 0) / 100)))) - paymentAmount).toFixed(2) as any : 0;
  }

  sendToOriginalInvoice() {
    this.router.navigateByUrl(`financial/invoices/${this.invoiceId}/update`);
  }

  /**
   * Update billing partner
   */
  updateBillingPartner(stepper: MatStepper) {

    if (!this.billingFormGroup.valid) {
      reactiveFormValidator(this.billingFormGroup);
      return;
    }
    const formValues = this.billingFormGroup.getRawValue();
    const partner = new Partner();
    const countryTmp = this.countryList.find(country => country.id === formValues.billingCountry);
    if (this.facility?.billingAddress) {
      partner.id = this.facility.billingAddress.id;
    }
    partner.zipCodeSuffix = formValues.billingSuffix;
    partner.firstName = formValues.billingFirstName;
    partner.middleName = formValues.billingMiddleName;
    partner.lastName = formValues.billingLastName;
    partner.name = formValues.billingFirstName + ' ' + (formValues.billingMiddleName ? (formValues.billingMiddleName + ' ') : '') + formValues.billingLastName;
    partner.email = formValues.billingEmail;
    partner.country = countryTmp;
    partner.city = formValues.billingCity;
    partner.state = formValues.billingState ? {id: formValues.billingState} : null;
    partner.county = formValues.billingCounty ? {id: formValues.billingCounty} : null;
    partner.street1 = formValues.billingAddress;
    partner.street2 = formValues.billingAddress2;
    partner.zipCode = formValues.billingZip;
    partner.phone = formValues.billingTelephoneNumber;
    partner.phoneCountryCode = formValues.prefix;
    partner.fax = formValues.billingFaxNumber;
    const facility = {facilityId: this.facility.id, partner};
    this.restService.request<Payment>(
      RequestMethod.POST,
      ApiEndpoints.ACCOUNT.PAYMENT,
      'create/partner_facility',
      {
        body: facility
      }
    ).subscribe(response => {
      if (response.success) {
        if (stepper.selected.state === 'one') {
          if (!this.cards || this.cards.length === 0){
            this.onAddNewCard();
            this.showBtnExistingPaymentMethod = false;
          }
          stepper.next();

        }
      } else {
        this.responseSnackBar.onResponseMessage('', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      }
    });
  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  /**
   * Add new card.
   * Re-render list of cards.
   */
  onAddNewCard(): void {
    this.isStripePaymentMethod = true;
    this.addNewCard = true;
    this.confirmBtnDisabled = false;
    this.useCardAsGuestBtn = true;
    this.isStripePayment = true;
    this.payment.createIntent = false;
    this.createPaymentIntent()
      .subscribe(pi => {
        this.paymentIntentId = pi.id;
        this.elementsOptions.clientSecret = pi.client_secret;
      });
    this.initStripeForm();
    //   this.initStripeElements();
    setTimeout(() => {
      const el = document.getElementById('stripe-form');
      el.scrollIntoView({behavior: 'smooth'});
    }, 500);
  }

  bankTransfer() {
    this.isBankTransfer = true;
    this.isStripePayment = false;
    this.isStripePaymentMethod = false;
    this.paymentFormGroup.get('ref').enable();
    this.updateAmountToPay();
  }

  back() {
    this.isBankTransfer = false;
    this.isStripePayment = false;
    this.paymentFormGroup.get('ref').disable();

    if (this.cards.length === 0){
      this.isStripePayment = true;
      this.onAddNewCard();
      this.showBtnExistingPaymentMethod = false;
    }
    this.updateAmountToPay();
  }

  validatePaymentInformation(): boolean {
    if (this.isStaff && !this.termsAccepted) {
      this.responseSnackBar.onResponseMessage('Agree to Terms and Conditions', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      return false;
    }
    const enabledControls = this.optionalInvoiceControls.controls.filter(ctrl => ctrl.enabled);
    const allEnabledValid = enabledControls.every(ctrl => ctrl.valid);
    if (!this.mandatoryInvoiceForms.valid || !allEnabledValid){
      this.responseSnackBar.onResponseMessage('Payment Amount Exceeds Amount Residual', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      return false;
    }
    reactiveFormValidator(this.paymentFormGroup);
    const formValues = this.paymentFormGroup.getRawValue();
    if (this.isBankTransfer) {
      if (!this.paymentFormGroup.valid) {
        this.responseSnackBar.onResponseMessage('Please fill payment fields', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        return false;
      }
    }
    if (this.invoices.length <= 0) {
      this.responseSnackBar.onResponseMessage('Please select at least one invoice!', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      return false;
    }
    if (formValues.amount < 0.5) {
      this.responseSnackBar.onResponseMessage('Minimum amount to pay is $0.5', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      return false;
    }
    this.payment.paymentInvoices = this.invoices.map(it => {
      return {payment: {
                id: null
              },
              invoice: {
                id: it.id
              },
              amount: it.amountToPay};
    });
    this.payment.paymentType = PaymentTypeEnum.INBOUND;
    this.payment.origin = this.invoices.reduce((accumulator, item) => accumulator += (item.number + ' '), '');
    this.payment.currency = this.company.currency;
    this.payment.partner = this.facility.partner;
    this.payment.amount = this.amountToPay;
    this.payment.financeFee = this.processingFee;
    if (!this.isBankTransfer && !this.isStripePaymentMethod) {
      const dateNow = new Date();
      if (!this.cards || this.cards < 1) {
        this.responseSnackBar.onResponseMessage('Please add a card', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        return false;
      }
      const defaultCard = this.cards.filter(it => it.id === this.defaultCard)[0];
      if (!defaultCard) {
        this.responseSnackBar.onResponseMessage('Please set a Default Payment Method', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        return false;

      }
      if (defaultCard.exp_year < dateNow.getFullYear() || (defaultCard.exp_year === dateNow.getFullYear() && defaultCard.exp_month < (dateNow.getMonth() + 1))) {
        this.responseSnackBar.onResponseMessage('The card is Expired', GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        return false;
      }
    }
    this.payment.journal = this.isBankTransfer ? this.journals.filter(x => x.type === 'BANK')[0] : this.journals.filter(x => x.type === 'STRIPE')[0];
    this.payment.description = formValues.description;
    this.payment.ref = formValues.ref;
    return true;

  }

  completePayment(event, stepper: MatStepper) {
    if (this.validatePaymentInformation()) {
      if (this.isBankTransfer) {
        this.createBankPayment(event, stepper);
      } else if (!this.isBankTransfer) {
        if (this.isStripePaymentMethod) {
          this.payStripe(event, stepper);
        } else {
          this.payStripeSavedPM(event, stepper);
        }
      }
    } else {
      event.onComplete();
    }
  }

  createBankPayment(event, stepper: MatStepper) {
    const action = 'create/payment';

    this.restService.request<Payment>(
      RequestMethod.POST,
      ApiEndpoints.ACCOUNT.PAYMENT,
      action,
      {
        body: this.payment
      }
    ).subscribe(response => {
      if (response.success) {
        this.saveCardDisabled = false;
        if (stepper.selected.state === 'two') {
          stepper.next();
          setTimeout(() => {
            if (!this.invoiceId) {
              this.router.navigateByUrl(`financial/payments`);
            } else if (!this.isFacApplication) {
              if (this.isInvoiceForm) {
                this.router.navigateByUrl(`financial/invoices/${this.invoiceId}/update`);
              } else {
                this.router.navigateByUrl(`financial/invoices`);
              }
            }
          }, 3000);
        }
      } else {
        this.saveCardDisabled = false;
        this.responseSnackBar.onResponseMessage(response?.error?.message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        event.onComplete();
      }
    });
  }

  private getAllCards(): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.READ}/cards`;
    this.restService
      .restRequest<any>(
        RequestMethod.GET,
        URL
      )
      .subscribe(response => {
        if (response.success) {
          this.cards = response.data.cards;
          this.defaultCard = response.data.defaultCard;
          this.updateAmountToPay();
        }
      });
  }

  private initPermissions(): void {
    this.permissions = {
      canUserCreateAndUpdateCard: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.UPDATE),
      canUserDeleteCard: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.DELETE)
    };
  }

  private initStripeForm(): void {
    this.stripeForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(255), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]]
    });
    this.tooltipService = new TooltipService(this.stripeForm);
  }


  private initForm() {
    this.billingFormGroup = new FormGroup({
      billingFirstName: new FormControl(null,
        [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]),
      billingMiddleName: new FormControl(null,
        [Validators.maxLength(100), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]),
      billingLastName: new FormControl(null,
        [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]),
      billingEmail: new FormControl(null, Validators.compose([Validators.required, Validators.pattern(GeneralConstant.EMAIL_REGEX_VALIDATOR)])),
      billingCountry: new FormControl(this.prefix.id, Validators.required),
      billingCity: new FormControl(null, [Validators.required, Validators.maxLength(100), Validators.pattern(GeneralConstant.ALPHANUMERIC_AND_SYMBOL_REGEX_VALIDATOR)]),
      billingState: new FormControl({value: null, disabled: true}, Validators.required),
      billingCounty: new FormControl({value: null, disabled: this.facility?.partner?.state?.id == null}),
      billingAddress: new FormControl(null,
        [Validators.required, Validators.maxLength(255)]),
      billingAddress2: new FormControl(null,
        [Validators.maxLength(255)]),
      billingZip: new FormControl(null, [Validators.required, Validators.maxLength(10), Validators.pattern(GeneralConstant.ZIP_REGEX_VALIDATOR)]),
      billingSuffix: new FormControl(null, [Validators.maxLength(10), Validators.pattern(GeneralConstant.ZIP_REGEX_VALIDATOR)]),
      billingTelephoneNumber: new FormControl(null,
        [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern(GeneralConstant.PHONE_REGEX_VALIDATOR)]),
      prefix: new FormControl(this.prefix.id, Validators.required),
      billingFaxNumber: new FormControl(null, [Validators.minLength(2), Validators.maxLength(100), Validators.pattern(GeneralConstant.PHONE_REGEX_VALIDATOR)])
    });
    this.tooltipService = new TooltipService(this.billingFormGroup);
    // this.charChange = this.payment.description;
    this.paymentFormGroup = new FormGroup({
      //  journal: new FormControl(null, Validators.required),
      description: new FormControl(null, [Validators.maxLength(2000)]),
      ref: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      amount: new FormControl(this.invoice ? this.invoice.amountResidual : null,
        Validators.pattern(GeneralConstant.DECIMAL_NUMBER_REGEX_VALIDATOR))
    });
    this.tooltipService = new TooltipService(this.paymentFormGroup);
    if (this.isFacApplication) {
      this.paymentFormGroup.get('invoice').disable();
    } else if (this.invoiceId) {
      this.paymentFormGroup.get('invoice').disable();
    }
    this.discountPercentage = ((this.discount) / (this.invoice?.amountTotalBeforeDiscount)) * 100;
    this.subTotal = this.invoice?.amountTotalBeforeDiscount;
    this.form = this.fb.group({
      mandatoryInvoices: this.fb.array([]),
      optionalInvoices: this.fb.array([])
    });
    // this.form = this.fb.group({
    //    // FormArray
    // });
    const mandatoryControls = this.mandatoryInvoices.map(invoice =>
      this.fb.group({
        amountMandatory: [
          invoice.amountToPay || 0,
          [
            Validators.required,
            Validators.max(invoice.amountResidual || 0)
          ]
        ]
      })
    );
    this.form.setControl('mandatoryInvoices', this.fb.array(mandatoryControls));

    const optionalControls = this.optionalInvoices.map(invoice =>
      this.fb.group({
        amountOptional: [
          invoice.amountToPay || 0,
          [
            Validators.required,
            Validators.max(invoice.amountResidual || 0)
          ]
        ]
      })
    );
    const formArray = this.fb.array(optionalControls);
    formArray.controls.forEach(group => group.get('amountOptional').enable());

    this.form.setControl('optionalInvoices', formArray);

  }

  private fillData() {
    const addressInformation = this.facility?.billingAddress ?? this.facility?.primarySite?.partner;
    this.billingFormGroup.controls.billingFirstName.setValue(Util.unwrapSafely(addressInformation, 'firstName'));
    this.billingFormGroup.controls.billingMiddleName.setValue(Util.unwrapSafely(addressInformation, 'middleName'));
    this.billingFormGroup.controls.billingLastName.setValue(Util.unwrapSafely(addressInformation, 'lastName'));
    this.billingFormGroup.controls.billingEmail.setValue(Util.unwrapSafely(addressInformation, 'email'));
    this.billingFormGroup.controls.billingCountry.setValue(Util.unwrapSafely(addressInformation, 'country.id', this.prefix.id));
    this.billingFormGroup.controls.billingCounty.setValue(Util.unwrapSafely(addressInformation, 'county.id'));
    if (Util.unwrapSafely(addressInformation, 'country.id', this.prefix.id) === this.prefix.id) {
      this.billingFormGroup.controls.billingState.enable();
      this.getStatesById({value: this.prefix.id});
    }

    if (addressInformation?.state?.id) {
      this.billingFormGroup.controls.billingCounty.enable();
      this.getCountiesByStateId(addressInformation.state.id);
    }

    this.billingFormGroup.controls.billingState.setValue(Util.unwrapSafely(addressInformation, 'state.id'));
    this.billingFormGroup.controls.billingCity.setValue(Util.unwrapSafely(addressInformation, 'city'));
    this.billingFormGroup.controls.billingAddress.setValue(Util.unwrapSafely(addressInformation, 'street1'));
    this.billingFormGroup.controls.billingAddress2.setValue(Util.unwrapSafely(addressInformation, 'street2'));
    this.billingFormGroup.controls.billingZip.setValue(Util.unwrapSafely(addressInformation, 'zipCode'));
    this.billingFormGroup.controls.billingSuffix.setValue(Util.unwrapSafely(addressInformation, 'zipCodeSuffix'));
    this.billingFormGroup.controls.billingTelephoneNumber.setValue(Util.unwrapSafely(addressInformation, 'phone'));
    this.billingFormGroup.controls.prefix.setValue(Number(Util.unwrapSafely(addressInformation, 'phoneCountryCode', this.prefix.id)));
    this.billingFormGroup.controls.billingFaxNumber.setValue(Util.unwrapSafely(addressInformation, 'fax'));
    if (this.billingFormGroup.controls.prefix.value === null) {
      this.billingFormGroup.controls.prefix.setValue(this.prefix.id);
    } else {
      this.prefix = this.countryList.filter(item => (item.id === this.billingFormGroup.controls.prefix.value))[0];
    }
  }

  private getAllCountries() {
    this.locationService.getCountries().subscribe(
      result => {
        if (result) {
          this.countryList = result;
        } else {
          this.locationService.getCountries();
        }
      }
    );
  }

  getCounties(event) {
    if (event.isUserInput) {
      this.getCountiesByStateId(event.source.value);
    }
  }

  private getCountiesByStateId(stateId: number) {
    if (stateId) {
      this.locationService.getCounties(stateId).subscribe(response => {
        this.countyList = response;
        this.billingFormGroup.controls.billingCounty.enable();
      });
    } else {
      this.billingFormGroup.controls.billingCounty.disable();
    }
  }

  getStatesById(event) {
    if (event.value !== this.usaId) {
      this.stateList = null;
      this.billingFormGroup.controls.billingState.setValue(null);
      this.billingFormGroup.controls.billingState.disable();
      this.billingFormGroup.controls.billingCounty.setValue(null);
      this.billingFormGroup.controls.billingCounty.disable();
      return;
    }
    this.billingFormGroup.controls.billingState.enable();
    this.restService.request<PageableResponse<State>>(RequestMethod.GET, ApiEndpoints.RES.STATE,
      Actions.BASE_ACTIONS.READ + `/by_country/${this.usaId}?readAll=true`).subscribe(
      response => {
        if (response.success) {
          this.stateList = response.data.items;
          this.billingFormGroup.controls.billingState.enable();
        } else {
          this.responseSnackBar.onResponse(response);
        }
      }
    );
  }

  private getCompanyInfo() {
    const data = {
      fields: ['id', 'name', 'addressOne', 'salesEmail', 'phone', 'businessNumber', 'fiscalNumber', 'taxNumber', {city: ['id', 'name']}, {state: ['id', 'name']}, {country: ['id', 'name']}, {currency: ['id', 'name', 'symbol', 'position']}],
      conditions: [['id', '=', 1]],
      depth: 2
    };
    this.restService.request<PageableResponse<Company>>(RequestMethod.POST, ApiEndpoints.RES.COMPANY, Actions.BASE_ACTIONS.READ + '/fetch', {body: data}).subscribe(
      response => {
        if (response.success && response.data && response.data.items.length > 0) {
          this.company = response.data.items[0];
          if (this.company.id) {
            this.payment.company = this.company;
            if (this.company.currency.position === 'before') {
              this.currencySymbolBefore = this.company.currency.symbol;
            } else {
              this.currencySymbolAfter = this.company.currency.symbol;
            }
          }
        }
      });
  }

  closeAddNewCard() {
    this.addNewCard = false;
    this.isStripePayment = false;
    this.isStripePaymentMethod = false;
    this.showBtnExistingPaymentMethod = true;
    this.updateAmountToPay();
  }

  setFuturePayment(event) {
    this.setForFuturePayment = event.checked;
  }
}

